// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"NoDeclarationPlaceholder-module__placeholder___2_elC","info":"NoDeclarationPlaceholder-module__info___lVnnq"};